import { isCatalogPath, normalizeCatalogHubPath } from '@repo/config';
import type { IChromeConfig } from '@repo/web-chrome/chrome-config/chrome-config';

export function resolveChromeHref(config: IChromeConfig, href: string): string | null {
  if (!href.startsWith('/') || config.siteOrigin === config.catalogOrigin) {
    return null;
  }
  const belongsToCatalog = isCatalogPath(href);
  if (belongsToCatalog === config.isCatalogApp) {
    return null;
  }
  const origin = belongsToCatalog ? config.catalogOrigin : config.siteOrigin;
  return `${origin}${belongsToCatalog ? normalizeCatalogHubPath(href) : href}`;
}
